import { useEffect } from "react";

// Per-route meta for crawlers that render the React tree (prerender/bot mode).
// Absolute URLs (canonical/og:url) are intentionally omitted until the
// production domain is confirmed — a wrong canonical de-indexes the live site.
const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const INDEX_ROBOTS = "index, follow, max-image-preview:large, max-snippet:-1";
const SITE_URL = "https://allinhandmarketing.com"; // domain attached + SSL verified via deployer check
const OG_IMAGE = `${SITE_URL}/aih-og-image.png`;

export default function Seo({ title, description, path, noindex = false }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : INDEX_ROBOTS);
    if (path && !noindex) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = `${SITE_URL}${path}`;
      setMeta("property", "og:url", `${SITE_URL}${path}`);
      setMeta("property", "og:image", OG_IMAGE);
      setMeta("name", "twitter:image", OG_IMAGE);
    }
  }, [title, description, path, noindex]);
  return null;
}
